import React from 'react';
import { Checkbox, Tooltip } from '@material-ui/core';
import { useActions, useValues } from 'kea';

import geofencelogic from 'src/store/geofence';

const EnableButton = ({ row, index }) => {
	const { update, loading } = useActions(geofencelogic);

	const handle_edit = (e) => {
		let changed_geofence = row;
		changed_geofence.vehicles[index].enabled = e.target.checked;
		// change below to use a specialised function
		update(changed_geofence);
	}

	return (
		<>
			<Tooltip title='Enable/Disable this assignment'>
				<Checkbox
					disabled={loading}
					checked={row.vehicles[index].enabled}
					color="primary"
					onChange={(e) => handle_edit(e)}
					inputProps={{ 'aria-label': 'primary checkbox' }}
				/>
			</Tooltip>
		</>
	);
};

export default EnableButton;
